
// 招聘人员状态
export const statusList = [
  {name: '已关闭', value: 0},
  {name: '进行中', value: 1},
  {name: '已完成', value: 2},
]

export const getStatus = (value) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  const result = statusList.find(item => item.value === value)
  return typeof result === 'undefined' ? '-' : result.name
}

// 入职状态
export const jobStatusList = [
  {name: '未入职', value: 0},
  {name: '确定入职', value: 1},
  {name: '待入职', value: 2},
  {name: '不入职', value: 3},
  {name: '正式入职', value: 4},
]

export const getJobStatus = (value) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  const result = jobStatusList.find(item => item.value === value)
  return typeof result === 'undefined' ? '-' : result.name
}

// 面试状态
export const interviewResultList = [
  {name: '未通过', value: 0, viewName: '面试未通过'},
  {name: '通过', value: 1, viewName: '面试通过'},
  {name: '待定', value: 2, viewName: '面试结果待定'}
]

export const getInterviewResult = (value, isView = false) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  const result = interviewResultList.find(item => item.value === value)
  return typeof result === 'undefined' ? '-' : isView ? result.viewName : result.name
}

// 接受offer状态
export const acceptOfferStatusList = [
  {name: '未接受', value: 0, viewName: '未接受Offer'},
  {name: '接受', value: 1, viewName: '接受Offer'},
  {name: '不确定', value: 2, viewName: '不确定是否接受Offer'}
]

export const getacceptOfferStatus = (value, isView = false) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  const result = acceptOfferStatusList.find(item => item.value === value)
  return typeof result === 'undefined' ? '-' : isView ? result.viewName : result.name
}

// 渠道枚举
// 0:未知 1:51Job ,2:智联，3:猎聘网,4:拉勾网,5:BOSS直聘,6:Linkedin,7:脉脉,8:猎头,9:个人人脉10:内部推荐,11其他

export const channelCodeList = [
  {name: '未知', value: 0},
  {name: '51Job', value: 1},
  {name: '智联', value: 2},
  {name: '猎聘网', value: 3},
  {name: '拉勾网', value: 4},
  {name: 'BOSS直聘', value: 5},
  {name: 'Linkedin', value: 6},
  {name: '脉脉', value: 7},
  {name: '猎头', value: 8},
  {name: '个人人脉', value: 9},
  {name: '内部推荐', value: 10},
  {name: '其他', value: 11},
]

export const getChannelCode = (value) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  const result = channelCodeList.find(item => item.value === value)
  return typeof result === 'undefined' ? '-' : result.name
}



// WEBPACK FOOTER //
// ./src/config/recruitment.js